export const emergencyRoomDetailsFields = [
  'emergency_room_attendance_id',
  'specialty',
  'patient {',
  ' patient_id',
  ' name',
  ' socialName',
  ' gender',
  ' birthday',
  ' cpf',
  ' rg',
  ' email',
  ' phone',
  ' maritalStatus',
  ' company',
  ' religion',
  ' religion_id',
  '}',
  'symptoms {',
  ' painLocation {',
  '  location',
  '  intensity',
  ' }',
  ' lossStrength',
  ' difficultiesSpeakWalk',
  ' confusionMemoryLoss',
  ' otherPainLocation',
  ' fever',
  ' temperatureFever',
  ' breathingDifficulty',
  ' isHeartPalpitations',
  ' breathingOptions',
  ' details',
  ' chestRadiatingArm',
  ' abdominalPain',
  ' hypertensionDiabetes',
  '}',
  'accompanies {',
  ' accompanying_id',
  ' name',
  ' socialName',
  ' phone',
  ' email',
  ' isMain',
  ' sendSMS',
  ' sendEmail',
  '}'
]
